import { CheckInReports } from "@/features/check-in-reports/check-in-reports";

export const Route = createFileRoute({
  component: CheckInReports,
});
